import { textColor } from "./palette";

// DataGrid style overrides
export const dataGridOverrides = {
  MuiDataGrid: {
    styleOverrides: {
      cell: {
        '&.selected': {
          border: '2px solid blue !important',
          backgroundColor: 'rgba(173, 216, 230, 0.5)', // Açık mavi arka plan
          color: 'black', // Koyu metin rengi
          fontWeight: 'bold', // Kalın metin
        },
      },
      columnHeaders: {
        backgroundColor: '#e5e7eb',
      },
      overlayWrapper: {
        height: '200px !important',
      },
      row: {
        '&.MuiDataGrid-row--borderBottom': {
          background: 'red !important', // istediğiniz rengi buraya yazabilirsiniz
        },
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: '#e0f2fe !important', // Darker fintech blue hover
        },
      },
      columnHeaderRow: {
        backgroundColor: '#e5e7eb !important',
      },
      columnHeaderTitle: {
        color: textColor,
        fontWeight: 600,
        fontSize: '12px',
      },
      columnHeader: {
        backgroundColor: '#e5e7eb',
      },
      virtualScroller: {
        paddingBottom: '20px !important',
        '& .MuiDataGrid-virtualScrollerContent': {
          paddingBottom: '20px !important',
        },
      },
      virtualScrollerContent: {
        paddingBottom: '20px !important',
      },
      root: {
        '& .MuiDataGrid-virtualScroller': {
          paddingBottom: '20px !important',
        },
        '& .MuiDataGrid-virtualScrollerContent': {
          paddingBottom: '20px !important',
        },
        '& .MuiDataGrid-virtualScrollerRenderZone': {
          paddingBottom: '20px !important',
        },
        '& .MuiDataGrid-row:hover': {
          cursor: 'pointer !important',
          backgroundColor: '#e0f2fe !important',
        },
        '& .MuiDataGrid-row:hover .MuiDataGrid-cell': {
          backgroundColor: '#e0f2fe !important',
        },
        '& .MuiDataGrid-row:hover .MuiCheckbox-root': {
          color: '#1976d2 !important',
        },
      /*   border: '1px solid #d0d7de',
        borderRadius: '8px', */
      },
    },
  },
};
